import {
  logout,
  resetPassword,
  sendForgetVerifyCode,
} from "@/services/api/login";
import { LockOutlined, LogoutOutlined } from "@ant-design/icons";
import { history, useModel } from "@umijs/max";
import type { MenuProps } from "antd";
import { Button, Form, Input, message, Modal, Spin } from "antd";
import { createStyles } from "antd-style";
import React, { useRef, useState } from "react";
import { flushSync } from "react-dom";
import HeaderDropdown from "../HeaderDropdown";

export type GlobalHeaderRightProps = {
  menu?: boolean;
  children?: React.ReactNode;
};

export const AvatarName = () => {
  return (
    <span className="anticon">{localStorage.getItem("user") || "用户"}</span>
  );
};

const useStyles = createStyles(({ token }) => {
  return {
    action: {
      display: "flex",
      height: "48px",
      marginLeft: "auto",
      overflow: "hidden",
      alignItems: "center",
      padding: "0 8px",
      cursor: "pointer",
      borderRadius: token.borderRadius,
      "&:hover": {
        backgroundColor: token.colorBgTextHover,
      },
    },
  };
});

export const AvatarDropdown: React.FC<GlobalHeaderRightProps> = ({
  menu,
  children,
}) => {
  /**
   * 退出登录，并且将当前的 url 保存
   */
  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [sendCodeLoading, setSendCodeLoading] = useState(false);
  const [sendCodeTime, setSendCodeTime] = useState(0);
  const timerRef = useRef<ReturnType<typeof setInterval> | number>(0);
  const [form] = Form.useForm();
  type FieldType = {
    username?: string;
    code?: string;
    newPsw?: string;
    newPassword?: string;
  };
  const showModal = () => {
    setOpen(true);
    form.setFieldsValue({
      username: localStorage.getItem("user"),
    });
  };

  const handleOk = () => {
    if (form.getFieldValue("newPsw") !== form.getFieldValue("newPassword")) {
      message.error("两次密码不一致");
      return;
    }
    console.log(form.getFieldsValue());

    form.validateFields().then(async (values: any) => {
      console.log(values);
      setConfirmLoading(true);
      const response = await resetPassword({
        newPsw: values.newPsw,
        code: values.code,
      });
      if (response.code === 200) {
        message.success("修改密码成功,请重新登录");
        setConfirmLoading(false);
        setOpen(false);
        loginOut();
      } else {
        setConfirmLoading(false);
      }
    });
  };

  const startCountdown = () => {
    setSendCodeTime(60);
    timerRef.current = setInterval(() => {
      setSendCodeTime((prev) => {
        if (prev <= 1) {
          clearInterval(timerRef.current);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  const handleCancel = () => {
    console.log("取消");

    form.setFieldsValue({
      username: localStorage.getItem("user"),
      code: "",
      newPsw: "",
      newPassword: "",
    });
    setOpen(false);
  };
  const handleSendCode = async () => {
    setSendCodeLoading(true);
    const response = await sendForgetVerifyCode();
    if (response.code === 200) {
      message.success("验证码发送成功");
      setTimeout(() => {
        setSendCodeLoading(false);
      }, 60 * 1000);
      startCountdown();
    } else {
      message.error("发送验证码失败");
      setSendCodeLoading(false);
    }
  };

  const loginOut = async () => {
    await logout();
    const { search, pathname } = window.location;
    const urlParams = new URL(window.location.href).searchParams;
    const searchParams = new URLSearchParams({
      redirect: pathname + search,
    });
    /** 此方法会跳转到 redirect 参数所在的位置 */
    const redirect = urlParams.get("redirect");
    localStorage.clear();
    // Note: There may be security issues, please note
    if (window.location.pathname !== "/user/login" && !redirect) {
      history.replace({
        pathname: "/user/login",
        search: searchParams.toString(),
      });
    }
  };
  const { styles } = useStyles();

  const { initialState, setInitialState } = useModel("@@initialState");

  const onMenuClick: MenuProps["onClick"] = (event) => {
    const { key } = event;
    if (key === "logout") {
      flushSync(() => {
        setInitialState((s) => ({ ...s, currentUser: undefined }));
      });
      loginOut();
      return;
    }
    if (key === "reset") {
      showModal();
      return;
    }
    history.push(`/account/${key}`);
  };

  const loading = (
    <span className={styles.action}>
      <Spin
        size="small"
        style={{
          marginLeft: 8,
          marginRight: 8,
        }}
      />
    </span>
  );

  if (!initialState) {
    return loading;
  }

  if (!localStorage.getItem("token") || !localStorage.getItem("user")) {
    return loading;
  }

  const menuItems = [
/*    {
      key: "reset",
      icon: <LockOutlined />,
      label: "修改密码",
    },*/
    {
      key: "logout",
      icon: <LogoutOutlined />,
      label: "退出登录",
    },
  ];

  return (
    <div>
      <Modal
        title="修改密码"
        open={open}
        className="reset-modal"
        destroyOnHidden={true}
        footer={[
          <Button
            style={{ display: "none" }}
            key="cancel"
            onClick={handleCancel}
          >
            取消
          </Button>,
          <Button key="ok" type="primary" onClick={handleOk}>
            完成
          </Button>,
        ]}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
      >
        <Form
          name="basic"
          form={form}
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 16 }}
          style={{ maxWidth: 600 }}
          autoComplete="off"
        >
          <Form.Item<FieldType> label="手机号" name="username">
            <Input disabled />
          </Form.Item>
          <div style={{ position: "relative" }}>
            <Form.Item<FieldType>
              label="验证码"
              name="code"
              style={{ position: "relative" }}
              rules={[
                { required: true, message: "请输入验证码！" },
                { pattern: /^\d{4}$/, message: "验证码必须是4位数字！" },
              ]}
            >
              <Input placeholder="请输入4位验证码" maxLength={4} />
            </Form.Item>
            <Button
              type="text"
              disabled={sendCodeLoading}
              onClick={handleSendCode}
              style={{
                color: "#d95650",
                position: "absolute",
                right: 40,
                top: 0,
              }}
            >
              {sendCodeTime > 0 ? `${sendCodeTime}` : "发送验证码"}
            </Button>
          </div>

          <Form.Item<FieldType>
            label="新密码"
            name="newPsw"
            rules={[
              { required: true, message: "请输入密码！" },
              {
                validator: (_, value) => {
                  if (!value) {
                    return Promise.resolve();
                  }
                  // 长度校验
                  if (value.length < 6 || value.length > 16) {
                    return Promise.reject(
                      new Error("密码长度需在 6~16 位之间")
                    );
                  }
                  // 包含数字和字母的正则 (不区分大小写)
                  const hasLetter = /[a-zA-Z]/.test(value);
                  const hasNumber = /\d/.test(value);

                  if (!hasLetter || !hasNumber) {
                    return Promise.reject(
                      new Error("密码必须同时包含数字和字母")
                    );
                  }

                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input placeholder="请输入新密码" maxLength={16} minLength={6} />
          </Form.Item>
          <Form.Item<FieldType>
            label="确认密码"
            name="newPassword"
            rules={[{ required: true, message: "再次填写上面的密码" }]}
          >
            <Input placeholder="请输入确认密码" />
          </Form.Item>
        </Form>
      </Modal>
      <HeaderDropdown
        menu={{
          selectedKeys: [],
          onClick: onMenuClick,
          items: menuItems,
        }}
      >
        {children}
      </HeaderDropdown>
    </div>
  );
};
